import "./NewTransfer.css";

import { Calendar, momentLocalizer } from "react-big-calendar";
import React, { Component } from "react";

import Add from "@material-ui/icons/Add";
import AppointmentApiInvoker from "../../api/AppointmentApiInvoker";
import BusinessApiInvoker from "../../api/BusinessApiInvoker";
import Button from "../CustomButtons/Button";
import CalendarToday from "@material-ui/icons/CalendarToday";
import Card from "../Card/Card";
import CardBody from "../Card/CardBody";
import CardFooter from "../Card/CardFooter";
import CardHeader from "../Card/CardHeader";
import CardIcon from "../Card/CardIcon";
import EventWithIcon from "../EventWithIcon/EventWithIcon";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import PersonApiInvoker from "../../api/PersonApiInvoker";
import PropTypes from "prop-types";
import SchedulerService from "../../containers/SchedulerService";
import Table from "../Table/Table";
import ViewList from "@material-ui/icons/ViewList";
import { browserHistory } from "react-router";
import memory from "../../config/memory";
import moment from "moment";
import withStyles from "@material-ui/core/styles/withStyles";
import { withTranslation } from "react-i18next";
import CustomDialog from "../CustomDialog";
import SelectInput from "../SelectInput";
import FullLoading from "../FullLoading";
import CustomSweetAlert from "../CustomSweetAlert";
import { EditTransferService } from "../TransferAppointments/Traslado/EditTransferServiceDialog/ui/EditTransferServiceDialog";
import { ActionsColumn } from "../TransferAppointments/TransferAppointmentDetail/components/ActionsColumn/ActionsColumn";
import { getActions } from "../TransferAppointments/TransferAppointmentDetail/utils/actionsColumnUtils";
import ButtonSpinner from "../ButtonSpinner";

require("moment/locale/es.js");

const localizer = momentLocalizer(moment);

class NewTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metadata: {
        medicalData: {},
        diagnostic: {},
      },
      types: [
        { value: 'Sólo ida', id: 1 },
        { value: 'Sólo vuelta', id: 2 },
        { value: 'Ida y vuelta', id: 3 },
      ],
      type: '',
      transferAppointment:{},
      cancellations: [],
      cancellationReason: "",
      confirmMetadataEdit: false,
      saveChangesDisabled: false,
      bookings: [],
      itemToEdit:null,
      practiceModulesCopy: [],
      loading: false,
      openDetail: false,
      openConfirmCancel: false,
      openConfirmChanges: false,
      currentEvent: {},
      events: [],
      event_original: [],
      items: [],
      itemsCopy: [],
      updateErrors: {},
      status: "",
      alertErrorOpen: false,
      alertErrorMessage: "",
      alertOpen: false,
      alertStatus: "",
      appointment: null,
      showConfirmUndo: false,
      showConfirmSave: false,
      bookingErrors: [],
      alertMessageOpen: false,
      alertMessageColor: "danger",
      alertMessageMsg: "danger",
      rejecteds: [],
      calendarViewMode: "month",
      scheduleStatus: "",
      serviceProvider: null,
      confirmOpenNewAppointment: false,
      showConfirmationEditAppointment:false,
      busy: false,
      services: [],
      openService: false,
      disabledButton: true,
      customersOptions: [],
      transfer: props.location.state ? (() => {
        const { propertyToRemove, ...transferWithoutProperty } = props.location.state.transferObject;
        return transferWithoutProperty;
      })() : {},
      customerId: {},
      isSavingTransfer: false,
    };
    this.componentCleanup = this.componentCleanup.bind(this);
  }

  componentCleanup() {
    this.confirmUndo();
  }

  onUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };


  componentDidMount() {
    this.setCustomersOptions();
    memory.tempService = null;
    if(this.props?.location?.state?.transferObject){
      const {transferObject} = this.props.location.state
      this.getItems(transferObject)
      const { driver, ...transferWithoutItems } = transferObject
      this.setState((prevState) => ({
        ...prevState,
        transfer: transferWithoutItems
      }))
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.transfer !== this.state.transfer) {
        this.getItems(this.state.transfer);
    }
  }


  componentWillMount() {
    this.setCustomersOptions();
    window.addEventListener("unload", this.componentCleanup);
  }


  formatDate = (date) => {
    let newDate = moment(date);
    if (!newDate.isValid()) {

        return null;
    }

    let result = newDate.format('DD/MM/YYYY');

    return result;
  };


  saveEditedService = (service) => {

    const {transfer, itemSelect} = this.state
    const {
      recurrence,
      startTime,
      startDate,
      distance_suggested,
      time_end_suggested,
      hospital,
      driver
    } = service

    const i = transfer?.items.findIndex((obj) => obj.order === itemSelect)   
    if(i >= 0){
      let updatedTransferItems = [...transfer.items]

      const newObj = {         
        recurrenceType: recurrence.recurrenceType,
        every: recurrence.every,
        finish: recurrence.finish,
        finishDate: recurrence.finishDate,
        finishOcurrences: recurrence.finishOcurrences,
        monthDay: recurrence.monthRecurrence,
        quantityIntraday: recurrence.quantityIntraday,
        weekDays: recurrence.weekRecurrence.join(),
        distance: parseFloat(distance_suggested.replace(' km', '')),
        duration: time_end_suggested.replace(' mins', ''),
        hospital: {
            hospitalId: hospital.hospitalId
        },
        startTime,
        startDate,
        driver
      } 
      updatedTransferItems[i] = {...updatedTransferItems[i], ...newObj}
      const updatedTransfer = {...transfer, items: updatedTransferItems}
      this.getItems(updatedTransfer)
      this.setState((prevState) => ({...prevState, transfer: updatedTransfer}))
    }
    this.closeServiceEdit()
  }

  showItemData = (objectData, itemSelect, readOnly) => {
    this.setState((prevState) => ({...prevState, openEditService: true, itemToEdit:objectData, itemSelect: itemSelect, readOnly }));
  }

  getItems = async (object) => {
    const { t } = this.props;
    if (object.items) {
      const services = object.items.map((item) => {
        const actions = getActions("", {show: () => this.showItemData(object, item.order, true), edit: () => {this.showItemData(object, item.order, false)}, delete: () => this.openCancelAppointment(item.order)})
        return { order: item.order,
          type: t(`status.transferWay.${item.transferWay}`),
          serviceName: t(`status.transfer.${item.transferType}`) ,
          companyName: item?.companyIdPartnership?.companyName,
          events: this.formatBookings(object.schedules),
          startDate: this.formatDate(item.startDate ?? object.startDate),
          startTime: item.startTime ?? object.startTime,
          recurrence: object,
          quantity: item.quantity ?? 0,
          driver: item?.driver ?? {value: t("common.unassigned")},
          actions: <ActionsColumn actions={actions}/>}

      });

      this.setState((prevState) => ({
        ...prevState,
        services: services,
      }));
    }  
    try {
      const customerInfo = await new Promise((resolve, reject) => {
        PersonApiInvoker.getCustomer(object.customerId, resolve, reject);
      });
  
      const address = await new Promise((resolve, reject) => {
        PersonApiInvoker.getPersonsAddressMobility(object.customerId, resolve, reject);
      });
      const customer = customerInfo?.customer
      let addressData = address.find((obj) => obj.addressDefault)

      if(object.addressId){
        addressData = address.find((obj) => obj.addressId === object.addressId)
      }
      this.setState((prevState) => ({
        ...prevState,
        loading: false,
        customerId: customer.id,
        appointment: {
          customer: {
            customer: customer.personId,
            address: addressData.addressId,
            zone: addressData.geographicZone.detail,
            location: addressData.location.locationId,
            province: addressData.provinceName,
            address_name: addressData.street,
            latitude: addressData.latitude,
            longitude: addressData.longitude,
          },
          startDate: object.startDate,
          endDate: object.endDate,
        },
      }));
  
      const financier = await new Promise((resolve, reject) => {
        BusinessApiInvoker.getCustomersFinanciers(customer.personId, resolve, reject);
      });
  
      this.setState((prevState) => ({
        ...prevState,
        loading: false,
        appointment: {
          ...prevState.appointment,
          financier: {
            financierId: financier[0].financier.financierId,
            affiliateId: financier[0].affiliateId,
            financiers: financier,
          },
          provider: {
            dateStart: object.startDate,
            dateEnd: object.endDate,
          },
          appointmentId: object.customerId,
          appointmentStatus: object.status,
          schedules: object.schedules,
        },
      }));
    } catch (error) {
      console.error('** error', error);
    }
  }

  setCustomersOptions = () => {
    PersonApiInvoker.getCustomers((response) => {});
  };



  setProvider = (serviceProvider) => {
    this.setState((prevState) => ({...prevState, serviceProvider: serviceProvider }));
  };


  onBack = () => {
    browserHistory.push(`/solicitudes-traslado`);
  };

 
  setProviderF(value) {
    this.setState(prevState => ({
      ...prevState,
      transferAppointment: {
        ...prevState.transferAppointment,
        provider: value,
      }
    }));
  }

  setFinancier(value) {
    this.setState(prevState => ({
      ...prevState,
      transferAppointment:{
      ...prevState.transferAppointment,
      financierData: value,
      financierId: value.financierId ? value.financierId : "",
      affiliateId: value.affiliateId ? value.affiliateId : "",
      }
    })
  );
  }
 

  openAddService = () => {
    this.setState((prevState) => ({...prevState, openService: true }));
  };
  

  openCancelAppointment = (appointmentId) => {
    this.setState((prevState) => ({...prevState, selectedCancelAppointment: appointmentId, showConfirmDeleteAppointment: true })    
    );
  }

  constructCustomerFormValue = () => {
    const { appointment } = this.state;
    if (appointment && appointment.customer) {
      return {
        customer: appointment.customer.customer ?? this.props?.location?.state?.transferObject.customerId ?? null,
        address: appointment.customer.address ?? this.props?.location?.state?.transferObject.addressId ?? null,
        zone: appointment.customer.zone ?? null,
        location: appointment.customer.location ?? null,
        province: appointment.customer.province ?? null,
        address_name: appointment.customer.address_name ?? null,
      };
    }
    return null;
  };

  closeService = () => {
      this.setState(prevState => ({
        ...prevState,
        openService: false,        
      }));
  };

  closeServiceEdit = () => {
    this.setState((prevState) => ({
      ...prevState,
      openEditService: false,
    }));
  };

  continueService = ()=>{
    
    browserHistory.push({
      pathname: "/detalle-servicio",
      state: { appointment: this.state.transferAppointment,
        transfer: this.state.transfer
      }
  });
      
  }


  saveAppointment = () => {  
    this.setState({isSavingTransfer: true})
    const formattedItems = this.state.transfer.items.map((item) => ({...item, weekDays: item.weekDays.split(","), driver: item?.driver?.id ? {personId: item.driver.id} : null}))
    const newTransfer = {...this.state.transfer, items: formattedItems}
    AppointmentApiInvoker.postTransferAppointment(newTransfer, (response) => {
      if (response) {        
        browserHistory.push({
          pathname: "/solicitudes-traslado",
      });
      }
    }, () => this.setState({isSavingTransfer: false}));
  };

 
  selectedEvent(event) {
    this.setState((prevState) => ({...prevState, event: event, openService: true }));
  }

  eventColors(event, start, end, isSelected) {
    let backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor,
    };
  }

  handleChangeValue = (name,value) => {
    this.setState((prevState) => ({
      ...prevState,
      type:value
    }))
    this.setState(prevState => ({
      ...prevState,
      transfer: {
        ...prevState.transfer,        
        companyId: Number(localStorage.getItem("itlg_default_company_id")),
        customerId: prevState.transferAppointment?.customer,
        addressId: prevState.transferAppointment?.address,
        financierId: prevState.transferAppointment?.financierId,
        createEmployee: Number(localStorage.getItem("user_id")),
        status: "CREATED",
        type:value,        
        startDate: prevState.transferAppointment?.provider?.dateStart?.split(' ')[0] ?? prevState.transfer?.startDate,
        endDate: prevState.transferAppointment?.provider?.dateEnd?.split(' ')[0] ?? prevState.transfer?.endDate,
        items: prevState.transfer?.items ?? [],
      }
    }));

    this.setState(prevState => ({
      ...prevState,
      transferAppointment: {
        ...prevState.transferAppointment,
        transferWay: value,
      }
    }));

    
  };
  editItem = (order,value)=>{   
  const updatedItems = this.state.transfer.items.map(item => { 
    if (item.order === order) {      
      return {
        ...item,
        driver: { personId: value.driver },       
      };
    }
    return item; 
  });
  

  
  this.setState(prevState => ({
    ...prevState,
    transfer: {
      ...prevState.transfer,
      items: updatedItems
    }
  }));
  this.setState((prevState) => ({...prevState, showConfirmationEditAppointment: true, openEditService: false }))
  
  }

  setTranferType = (type) => {
    if (type === "STANDAR") {
      return "Traslado estándar";
    } else if (type === "RAMPA") {
      return "Traslado con rampa";
    } else if (type === "AMBULANCIA") {
      return "Traslado con ambulancia";
    }
  };

  formatBookings(data) {
    if(data){
      let bookings = data;      
      
      let result = [];
      bookings.map((b) => {
        if (b) {
          result.push({
            id: b.transferScheduleId,
            title: `${this.setTranferType(b.transferItemRequestId.transferType)}`,
            time_display: "",
            time_start: moment(b.startDateTime).format("HH:mm"),
            allDay: false,
            view: this.state.calendarViewMode,
            start: b.startDateTime,
            end: b.endDateTime,
            color: "F06292",
            employeeId: b.employeeId,
            status: b.transferScheduleStatus,
            type: b.type,
            errorDetail: "",
            origin: b,
          });
        }
      });
      this.setState((prevState) => ({...prevState, events: result }));
    }
  }


  setData = (validation) => {
    if (validation) {
      this.setState((prevState) => ({...prevState, disabledButton: false }));
    }
  };

  deleteAppointmentAction = () => {

    let filteredItems = this.state.transfer.items.filter(item => item.order !== this.state.selectedCancelAppointment)

    if(filteredItems.length > 0){
      filteredItems = filteredItems.map((item, i) => ({...item, order: i+1}))
    }

    this.setState(prevState => ({
      ...prevState,
      showConfirmDeleteAppointment: false,
      transfer: {
        ...prevState.transfer,
        items: filteredItems
      }
    }), () => {
      this.getItems(this.state.transfer)
    });
  }

  

  UNSAFE_componentWillUpdate(nextProps, nextState) {}

  disableAddService() {
    let validation = true
    const {transferAppointment} = this.state
    if(transferAppointment){
      const {
        customer,
        customerId,
        address,
        zone,
        location,
        province,
        geographicZoneId,
        financierId,
        affiliateId,
        provider,
      } = transferAppointment
    if (
      customer &&
      customerId &&
      address &&
      zone &&
      location &&
      province &&
      geographicZoneId &&
      financierId &&
      affiliateId &&
      provider?.dateStart &&
      provider?.dateEnd
    ) {
      validation = false
    }
  }
  return validation
    
  }

  render() {
    const { t } = this.props;
    const { appointment, customerId, openService, services, openEditService, showConfirmDeleteAppointment } =
      this.state;
      if ((!this.state?.transfer || this.props?.location?.state?.transferObject) && (!appointment && !appointment?.appointmentId)) {
        return (<FullLoading />)
      }
     
    return (
      <GridContainer>
       
        <GridItem xs={6} sm={6} md={6}>
          <SchedulerService.CustomerFormService
            disableAddress={services?.length > 0}
            setData={this.setData}
            onFilledCustomer={(value) => {
              this.setState((prevState) => ({
                ...prevState,
                transferAppointment: {...prevState.transferAppointment, ...value},
                customerId: {...prevState.customerId, ...value},
                addressId: value.address,
                zoneId: value.zone,
              }));
            }}
            value={this.constructCustomerFormValue()}
            onUpdateCustomers={this.onUpdateCustomers}
            onGetCustomers={() => {}}
          />
        </GridItem>

        <GridItem xs={6} sm={6} md={6}>
          <SchedulerService.FinancialFormService
            serviceType={"service"}
            customerId={customerId}
            onFilledProvider={(value) => this.setProviderF(value)}
            onFilledFinancier={(value) => this.setFinancier(value)}
            value={
              this.state.appointment
                ? {
                    provider: appointment.provider,
                    financier: appointment.financier,
                    customerId: appointment.customer,
                    dateStart: appointment.startDate,
                    dateEnd: appointment.endDate
                  }
                : null
            }
          />
        </GridItem>

        <GridItem className="schedule-form" xs={12} sm={12} md={12}>
          <Card>
            <CardHeader icon className="filters-header">
              <CardIcon color="secondary">
                <ViewList />
              </CardIcon>
              <h3 className="card-icon-title">{t("appointment.services")}</h3>
            </CardHeader>
            <CardBody className="appointments-content-body filtrable-table">
              <Table
                filterable
                loading={false}
                tableHeaderColor={"primary"}
                defaultPageSize={services.length > 10 ? 20 : 10}
                sortable
                tableHead={[
                  { Header: t("service.order"), accessor: "order" },
                  { Header: t("service.type"), accessor: "type" },
                  { Header: t("label.provider"), accessor: "companyName"},
                  { Header: t("service.name"), accessor: "serviceName" },
                  {
                    Header: t("service.start_date"),
                    accessor: "startDate",
                    sortMethod: (a, b) => this.sortDate(a, b),
                  },
                  {
                    Header: t("common.driver"),
                    accessor: "driver.value"
                  },
                  {
                    Header: t("service.quantity"),
                    accessor: "quantity",
                    sortMethod: (a, b) => this.sortDate(a, b),
                  },
                  {
                    Header: t("appointment.table.actions"),
                    accessor: "actions",
                    sortable: false,
                    filterable: false,
                  },
                ]}
                tableData={services}
                colorsColls={["primary"]}
                className="-striped -highlight filtrable sticky"
                showPaginationTop={false}
                showPaginationBottom={true}
              />
            </CardBody>
            <CardFooter className="schedule-form-submit buttonFooter">
              {//!memory.tempService && (
                <Button
                  className="buttonPlusFooter"
                  onClick={() => this.openAddService()}
                 disabled={this.disableAddService() ||  this.state.isSavingTransfer} 
                  color="primary"
                >
                  <Add />
                </Button>
              //)
              }
            </CardFooter>
          </Card>


          {appointment &&
            appointment.schedules &&
            appointment.appointmentStatus === "TRANSFER_SCHEDULES_ASSIGNED" && (
              <Card>
                <CardHeader icon className="filters-header">
                  <CardIcon color="secondary">
                    <CalendarToday />
                  </CardIcon>
                  <h3 className="card-icon-title">{t("appointment.agenda")}</h3>
                </CardHeader>
                <CardBody className="calendar-booking" calendar>
                  <Calendar
                    selectable
                    showMultiDayTimes={true}
                    localizer={localizer}
                    events={this.state.events}
                    defaultView="month"
                    step={30}
                    views={["month"]}
                    scrollToTime={new Date(1970, 1, 1, 6)}
                    defaultDate={new Date()}
                    onSelectEvent={(event) => this.selectedEvent(event)}
                    eventPropGetter={this.eventColors}
                    messages={{
                      next: t("common.next"),
                      previous: t("common.prev"),
                      today: t("common.today"),
                      month: t("common.month"),
                      week: t("common.week"),
                      day: t("common.day"),
                      event: t("common.event"),
                      date: t("common.date"),
                      time: t("common.hour"),
                    }}
                    components={{
                      event: EventWithIcon,
                    }}
                  />
                </CardBody>
              </Card>
            )}

          <GridContainer className="buttons-containers">
            <GridItem xs={10} sm={10} md={10}>
              <Button onClick={() => this.onBack()}>
                {t("appointment.cancel")}
              </Button>
            </GridItem>
            <GridItem xs={2} sm={2} md={2} style={{ textAlign: "right" }}>
                <ButtonSpinner
                  label= {t("appointment.save")}
                  labelLoading={t("common.saving")}
                  className="align-right"
                  color="blue"
                  disabled={!services.length || this.state.isSavingTransfer}
                  loading={this.state.isSavingTransfer}
                  onClick={() => this.saveAppointment()}
                />
                 
                
              
            </GridItem>
          </GridContainer>
        </GridItem>

        {showConfirmDeleteAppointment &&
          <CustomSweetAlert
            type="warning"
            onConfirm={this.deleteAppointmentAction}
            onCancel={() => this.setState((prevState) =>({...prevState, showConfirmDeleteAppointment: false }))}
            confirmBtnCssClass="primary"
            cancelBtnCssClass="danger"
            title={t('appointment.created.cancel.title')}
            cancelBtnText={t('appointment.created.cancel.cancel')}
            confirmBtnText={t('appointment.created.cancel.confirm')}
            showCancel={true}
            message={<p>{t('appointment.created.cancel.delete')} </p>}
          />
        }


        {openEditService && (
          <EditTransferService
            open={openEditService}
            onClose={this.closeServiceEdit}
            onSave={this.saveEditedService}
            disabled={this.state.readOnly}
            itemData={this.state?.itemToEdit}
            customer={appointment ? appointment.customer : customerId}
            itemSelect={this.state?.itemSelect}
          />
        )}


        <CustomDialog
          maxWidth={"xs"}
          title={t('appointmentTransfer.type.select')}
          open={openService}
          onClose={() => this.closeService()}
        >
            <div>
              <GridContainer
                className={"ps-child modules-form"}
              >
                <GridItem xs={12} sm={12} md={12} className="componentType">
                  <SelectInput
                    label={t('tools.type')}
                    elements={this.state.types}
                    onSelectedValue={(value) =>
                      this.handleChangeValue("transferWay", value)
                    }
                    value={this.state.type}
                  />
                </GridItem>
              </GridContainer>
            </div>
            <CardFooter className="schedule-form-submit buttonFooter">
              <Button
                className="buttonPlusFooter"
                onClick={() => this.continueService()}
                color="primary"
                disabled={!this.state.type}
              >
                {t('common.continue')}
              </Button>
            </CardFooter>
        </CustomDialog>
      </GridContainer>
    );
  }
}

NewTransfer.defaultProps = {
  selectedSchedules: [],
  onSaveSchedulesAppointment: () => {},
};

NewTransfer.propTypes = {
  selectedAppointment: PropTypes.object,
  providers: PropTypes.array,
  appointmentTools: PropTypes.array,
  selectedSchedules: PropTypes.array,
  onSelectAppointmentObject: PropTypes.func,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onGetAppointmentsTools: PropTypes.func,
  onDeleteAppointmentTool: PropTypes.func,
  onGetSchedulesAppointment: PropTypes.func,
  onSaveSchedulesAppointment: PropTypes.func,
};

const styles = {
  cardHeader: {
    zIndex: "0 !important",
  },
};

export default withStyles(styles)(withTranslation()(NewTransfer));
